module.exports = __webpack_public_path__ + "static/media/Kwikset.65654513.svg";